module.exports = __webpack_public_path__ + "img/Bpoint3.7a9eedbd.png";